/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_No_CandidatesInputs */

const cs_signing_no_candidates = /** @type {(inputs: Signing_No_CandidatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádná oprávněná PDF. Nejprve nahrajte smlouvu/právní PDF v Dokumentech.`)
};

const en_signing_no_candidates = /** @type {(inputs: Signing_No_CandidatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No eligible PDFs found. Upload a contract/legal PDF in Documents first.`)
};

/**
* | output |
* | --- |
* | "No eligible PDFs found. Upload a contract/legal PDF in Documents first." |
*
* @param {Signing_No_CandidatesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_no_candidates = /** @type {((inputs?: Signing_No_CandidatesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_No_CandidatesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_no_candidates(inputs)
	return cs_signing_no_candidates(inputs)
});